import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'fin-form-fields',
  styleUrls: ['form-fields.component.scss'],
  templateUrl: 'form-fields.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FormFieldsComponent {}
